<template>
  <div>
    <a-form :form="form" id="form">
      <a-row :gutter="16">
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">

          <a-form-item label="Jenis Anggaran">
<!--              :disabled="mode == 'Edit'"-->
            <a-select
                    :disabled="disableAnggaran"
                    showSearch
                    :not-found-content="null"
                    option-filter-prop="children"
                    v-decorator="[
              'jenis_anggaran',
              {
                rules: [{ required: true }],
                initialValue: mode == 'Edit' ? initialData.jns_anggaran_id:initialData.jns_anggaran_id,
              },
            ]"
                    @change="handleJenisAnggaran"
            >
              <a-select-option v-for="item in getJenisAnggaran" :key="item.value">{{
                item.text
                }}</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="Cost Center">
          <!-- <a-row :gutter="16">
            <a-col :xs="{ span: 24 }" :lg="{ span: 16 }"> -->
              <a-select
                :disabled="disableCostCenter"
                showSearch
                :not-found-content="null"
                option-filter-prop="children"
                v-decorator="[
                  'cost_center',
                  {
                    rules: [{ required: true }],
                    initialValue: initialData.cost_center,
                  },
                ]"
                ref="costCntr"
                @change="handleCost"
              >
                <a-select-option
                  v-for="item in costCenter"
                  :key="item.value"
                  >{{ item.text }} ({{item.nama_pekerjaan ? item.nama_pekerjaan : '-'}})</a-select-option
                >
              </a-select>
            <!-- </a-col> -->
<!--            <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">-->
<!--              <a-button type="primary"-->
<!--                :disabled="mode == 'Edit' ? true:!modalanggaran.enabled"-->
<!--                @click="showChoiceModal"-->
<!--                :loading="modalanggaran.loadingButton"-->
<!--                size="small"-->
<!--                >-->
<!--                select financing code-->
<!--              </a-button>-->
<!--            </a-col>-->
            <!-- </a-row> -->
          </a-form-item>

          <a-form-item label="Peruntukan">
            <a-select
              :disabled="disablePeruntukan"
              showSearch
              :not-found-content="null"
              option-filter-prop="children"
              v-decorator="[
                'peruntukan',
                {
                  rules: [{ required: true }],
                  initialValue: initialData.peruntukan,
                },
              ]"
              :loading="load.pipeline"
              @change="handlePeruntukan"
            >
              <a-select-option v-for="item in peruntukan" :key="item.value">{{
                item.text
              }}</a-select-option>
            </a-select>
          </a-form-item>

          <a-row :gutter="24">
            <a-col span="0" style="display:hidden">
              <a-form-item label="Activity Type" v-if="1==0 && $refs.costCntr && $refs.costCntr.value && $refs.costCntr.value.includes('MARDEV')">
                <a-select placeholder="Please Select" 
                ref="refactivity_type"
                v-decorator="[
                  'activity_type',
                  { rules: [{ required: true }], initialValue: initialData.activity_type },
                ]"
                @change="changeActivity_type" class="width-full" disabled>
                  <a-select-option v-for="item in getMARDEVActivity.type" :key="item">
                    {{item}}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col span="24">
              <a-form-item label="Activity" v-if="1==0 && $refs.costCntr && $refs.costCntr.value && $refs.costCntr.value.includes('MARDEV') && $refs.refactivity_type && $refs.refactivity_type.value=='Non Project'">
                <a-select placeholder="Please Select" 
                v-decorator="[
                  'activity',
                  { rules: [{ required: true }], initialValue: initialData.activity },
                ]" class="width-full">
                  <a-select-option v-for="item in getMARDEVActivity.activity" :key="item">
                    {{item}}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="Pipeline" v-if="1==0 && $refs.costCntr && $refs.costCntr.value && $refs.costCntr.value.includes('MARDEV') && $refs.refactivity_type && $refs.refactivity_type.value=='Project Penetration'">
                <a-select
                  :disabled="disablePipeline"
                  showSearch
                  :loading="load.pipeline"
                  :not-found-content="null"
                  option-filter-prop="children"
                  v-decorator="[
                    'pipeline_id',
                    {
                      rules: [{ required: true }],
                      initialValue: initialData.pipeline_id,
                    },
                  ]"
                >
                  <a-select-option v-for="item in pipelineList" :key="item.pipeline_id">
                    [{{ item.pipeline_no}}] {{ item.definitions }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>

<!--          <a-form-item label="Sub Peruntukan">-->
<!--            <a-select-->
<!--              :disabled="mode == 'Edit'?true:subPeruntukan==0"-->
<!--              showSearch-->
<!--              :not-found-content="null"-->
<!--              option-filter-prop="children"-->
<!--              v-decorator="[-->
<!--                'sub_peruntukan',-->
<!--                {-->
<!--                  rules: [{ required: true }],-->
<!--                  initialValue: initialData.sub_peruntukan,-->
<!--                },-->
<!--              ]"-->
<!--              @change="handleSubPeruntukan"-->
<!--            >-->
<!--              <a-select-option v-for="item in subPeruntukan" :key="item.value">{{-->
<!--                item.text-->
<!--              }}</a-select-option>-->
<!--            </a-select>-->
<!--          </a-form-item>-->
<!--          <a-form-item label="Kode Anggaran">-->
<!--            <a-select-->
<!--              :disabled="mode == 'Edit' ? true:anggaran.length==0"-->
<!--              showSearch-->
<!--              @change="handleCodeAnggarn"-->
<!--              :not-found-content="null"-->
<!--              option-filter-prop="children"-->
<!--              v-decorator="[-->
<!--                'kode_anggaran',-->
<!--                {-->
<!--                  rules: [{ required: true }],-->
<!--                  initialValue: initialData.kode_anggaran,-->
<!--                },-->
<!--              ]"-->
<!--            >-->
<!--              <a-select-option v-for="item in anggaran" :key="item.value">{{-->
<!--                item.text-->
<!--              }}</a-select-option>-->
<!--            </a-select>-->
<!--          </a-form-item>-->
          <a-form-item label="Description">
            <a-input
              v-decorator="[
                'deskripsi_sppds',
                {
                  rules: [{ required: true }],
                  initialValue: initialData.deskripsi_sppds,
                },
              ]"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">

          <a-form-item label="Created Date">
            <a-date-picker
                    placeholder="Select Date"
                    :disabled="mode === 'Edit'"
                    :format="getDefaultDateFormat"
                    v-decorator="[
                'tanggal_sppds',
                {
                  rules: [{ required: true }],
                  initialValue: moment(
                    initialData.tanggal_sppds,
                    getDefaultDateFormat
                  ),
                },
              ]"
            />
          </a-form-item>

          <a-form-item label="Assignment Type">
            <a-radio-group
              :disabled="mode === 'Edit'"
              buttonStyle="solid"
              v-decorator="[
                'jenis_perintah',
                {
                  rules: [{ required: true }],
                  initialValue: initialData.jenis_perintah,
                },
              ]"
            >
              <a-radio-button value="PD">SPPD</a-radio-button>
              <a-radio-button value="PS">SPPS</a-radio-button>
            </a-radio-group>
          </a-form-item>
          <a-form-item label="PD/S Schedule">
            <a-range-picker
              :placeholder="['Start month', 'End month']"
              :format="getDefaultDateFormat"
              v-decorator="[
                'jadwalDinas',
                {
                  rules: [{ required: true }],
                  initialValue: [
                    moment(initialData.jadwalDinas[0], getDefaultDateFormat),
                    moment(initialData.jadwalDinas[1], getDefaultDateFormat),
                  ],
                },
              ]"
            ></a-range-picker>
          </a-form-item>
          <!-- <a-form-item label="Estimated Cost (IDR)">
            <a-input-number
              :min="0"
              class="m-text-numberRight  m-width-full"
              :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
              :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
              @keydown="onlyNumber"
              v-decorator="['est_cost', { rules: [{ required: true }], initialValue: initialData.est_cost }]"
            ></a-input-number>
          </a-form-item> -->
        </a-col>
      </a-row>
    </a-form>
    <a-modal v-model="modalanggaran.visible" v-if="modalanggaran.visible" title="Choice Financing Code" :footer="null" :width="700" >
      <a-tree-select
        v-model="modalanggaran.value"
        show-search
        style="width: 100%"
        @change="handlechoiceCost"
        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
        :tree-data="modalanggaran.tree"
        treeNodeFilterProp="children"
        :filterTreeNode="filterTreeNode"
        placeholder="Please select"
        allow-clear
        tree-default-expand-all
      >
        <span slot="title" slot-scope="item">
          <table style="width:100%">
            <tr>
              <td>
                <span> {{item.texttitle}} - {{item.kode_anggaran}}</span>
              </td>
              <td>
                <span style="float:right"> {{formatRupiah(parseFloat(item.rekap))}} </span>
              </td>
            </tr>
          </table>
        </span>
      </a-tree-select>
    </a-modal>
  </div>
</template>

<script>
import axios from "axios";
import _ from "lodash";
import moment, { localeData } from "moment";
import { mapGetters, mapActions } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import GlobalMethod from "@/mixins/GlobalMethod.js";
export default {
  name: "Informasi",
  props: {
    id: String,
    data: {},
    mode: String,
    listPembelian: Array,
  },
  mixins: [CurrencyFormat, GlobalMethod],
  data() {
    return {
      activeProject: [],
      category: "Project",
      // form: this.$form.createForm(this),
      pimpro: localStorage.getItem("pimpro") || "",
      dataValid: {},
      peruntukan: [],
      subPeruntukan: [],
      anggaran: [],
      costCenter:[],
      modalanggaran: {
        visible: false,
        enabled: false,
        loadingButton:false,
        value: undefined,
        tree: {},
        searchValue: ""
      },
      pipelineList: [],
      load:{
        pipeline: false
      },
      selectedCostCenter: []
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  async created() {
    await this.$store.dispatch("FETCH_COST_CENTER_NON_TAKTIS");
    await this.$store.dispatch("FETCH_COST_CENTER_SPPD");
  },
  mounted() {
    if(this.data && this.data.jenis_anggaran=='07'){
      this.selectedCostCenter = this.data.jenis_anggaran || this.data.jns_anggaran_id
    }
  },
  computed: {
    ...mapGetters([
      "getNonTaktis",
      "getScreen",
      "getAuth",
      "getStandartFormatDate",
      "getDefaultDateFormat",
      "getAllKaryawan",
      "getJenisAnggaran",
      "getMARDEVActivity"
    ]),
    initialData: function() {
      if (this.data === undefined || this.data.length <= 0) {
        return {
          jenis_sppds: "Project",
          jenis_perintah: "PD",
          tanggal_sppds: moment().utc(true),
          usedfor_sppds: "",
          jadwalDinas: [moment().utc(true), moment().utc(true)],
          deskripsi_sppds: "",
          cost_center: "",
          peruntukan: "",
          sub_peruntukan: "",
          kode_anggaran: "",
          jenis_anggaran: "",
          //est_cost: 0
          pipeline_id: "",
          activity: null,
          activity_type: 'Non Project',
        };
      } else {
          if(this.data.jns_anggaran_id || this.data.jenis_anggaran){
              this.initJenisAnggaran(this.data.jns_anggaran_id || this.data.jenis_anggaran);
              this.handleCost(this.data.cost_center);
              this.initPeruntukan (this.data.peruntukan);
          }





        // this.handleSubPeruntukan(this.data.sub_peruntukan);

        // }


        // this.category = this.data.jenis_sppds;
        return {
          jenis_sppds: this.data.jenis_sppds,
          jenis_perintah: this.data.jenis_perintah,
          tanggal_sppds: moment(this.data.tanggal_sppds).format(
            this.getDefaultDateFormat
          ),
          usedfor_sppds: this.data.usedfor_sppds,
          jadwalDinas: [
            moment(this.data.jadwalDinas[0]).format(this.getDefaultDateFormat),
            moment(this.data.jadwalDinas[1]).format(this.getDefaultDateFormat),
          ],
          deskripsi_sppds: this.data.deskripsi_sppds,
          pimpro_atasan: this.data.pimpro_atasan,
          cost_center: this.data.cost_center,
          // cost_center: (this.getNonTaktis.cost_center.filter((obj)=>obj.jns_anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0)),
          peruntukan: this.data.peruntukan,
          sub_peruntukan: this.data.sub_peruntukan,
          kode_anggaran: this.data.kode_anggaran,
          jenis_anggaran: this.data.jenis_anggaran || this.data.jns_anggaran_id,
          jns_anggaran_id: this.data.jns_anggaran_id || this.data.jenis_anggaran,
          //est_cost: this.data.est_cost
          pipeline_id: this.data.pipeline_id,
          activity: this.data.activity,
          activity_type: this.data.type_activity ||this.data.activity_type
        };
      }
    },
    disableCostCenter:  function () {
        if(this.mode==='Create'){
            if(this.costCenter.length > 0){
                if(this.listPembelian.length > 0){
                    return true;
                }
                return false;
            }else{
                return true;
            }
        }else{
            return true;
        }
    },
    disablePeruntukan:  function () {
        if (this.mode === 'Create') {
            if (this.peruntukan.length > 0) {
                if (this.listPembelian.length > 0) {
                    return true;
                }
                return false;
            } else {
                return true;
            }
        } else {
            return true;
        }
    },
    disablePipeline:  function () {
        // if (this.mode === 'Create') {
            if (this.pipelineList.length > 0) {
                    return false;
            } else {
                return true;
            }
        // } else {
        //     return true;
        // }
    },
    disableAnggaran: function () {
        if (this.mode === 'Create') {
            if (this.listPembelian.length > 0) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    } ,
  },
  methods: {
    moment,
    filterTreeNode(input, option) {
      return (
        option.data.props.texttitle==undefined || (option.data.props.texttitle ? option.data.props.texttitle : "").toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
        (option.data.props.kode_anggaran ? option.data.props.kode_anggaran : "").toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    handlechoiceCost(val){
      if (val){
        let kod = val.split(";")
        this.$nextTick(function () {
          this.handlePeruntukan(kod[0]);
          this.form.setFieldsValue({
              peruntukan: kod[0],
          });
          // this.handleSubPeruntukan(kod[1]);
          this.form.setFieldsValue({
              sub_peruntukan: kod[1],
              kode_anggaran: kod[2]
          });
        });
      }else{
        this.$nextTick(function () {
          this.form.setFieldsValue({
              peruntukan: undefined,
              sub_peruntukan: undefined,
              kode_anggaran: undefined
          });
        });
      }
      this.modalanggaran.visible = false
    },
    showChoiceModal(){
      this.modalanggaran.visible = true
    },
    async handleCost(e) {
      // this.modalanggaran.enabled = false
      // this.modalanggaran.loadingButton = true
      // axios({
      //   method: "get",
      //   url: this.$serviceUrl + "anggaran/tree_anggaran",
      //   params: {
      //     anggaran_id: e,
      //     tlc: this.getAuth.username,
      //     non_taktis: 'non_taktis'
      //   },
      //   auth: {
      //     username: this.getAuth.username,
      //     password: this.getAuth.password,
      //   },
      //   headers: {
      //     "X-API-KEY": this.getAuth.apikey,
      //   },
      // })
      //   .then((response) => {
      //     this.modalanggaran.enabled = true
      //     this.modalanggaran.loadingButton = false
      //     this.modalanggaran.tree = response.data.tree;
      //   })
      //   .catch((err) => {
      //     let responses = Object.assign({}, err.response);
      //   });

      this.load.pipeline = true
      axios({
        method: "get",
        url: this.$serviceUrl + "sppds/pipeline",
        params: {
          anggaran_id: e,
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.pipelineList = response.data.data?response.data.data:[]          
        })
        .catch((err) => {
          let responses = Object.assign({}, err.response);
          this.displayMessageValue("error", responses);
        });


      // this.form.resetFields(["peruntukan", "sub_peruntukan", "kode_anggaran"]);
      //   this.form.setFieldsValue({peruntukan:null});
      
      this.subPeruntukan = [];
      this.anggaran = [];

      const peruntukan = this.getNonTaktis && this.getNonTaktis.peruntukan? this.getNonTaktis.peruntukan.filter(
        (obj) => obj.anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      ):[];
      this.peruntukan = peruntukan;

      const tempPeruntukan = this.form.getFieldValue("peruntukan");
      if(tempPeruntukan && peruntukan.filter(item=>item.value==tempPeruntukan).length==0){
        this.$nextTick(() => {
          this.form.setFieldsValue({
            peruntukan: null
          })
        });
      }

      this.load.pipeline = false
    },
    handlePeruntukan(e) {

      this.form.resetFields(["pipeline_id","sub_peruntukan", "kode_anggaran"]);
      this.anggaran = [];
      const filter = this.getNonTaktis.sub_peruntukan.filter(
        (obj) => obj.peruntukan_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );

      this.subPeruntukan = filter;
    },
    handleSubPeruntukan(e) {
      this.form.resetFields(["kode_anggaran"]);
      const filter = this.getNonTaktis.kode_anggaran.filter(
        (obj) => obj.anggaran_dtl_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );
      this.anggaran = filter;
    },
    handleCodeAnggarn(e){
      let forms = this.form.getFieldsValue();
      this.modalanggaran.value = forms.peruntukan+";"+forms.sub_peruntukan+";"+e
    },
    clearForm() {
      this.form.resetFields();
    },
    async getApproval(anggaran_id) {
      let params = {};
      if (this.mode=="Create"){
          params = {
              tlc : this.getAuth.username,
              anggaran_dtl_val_id: anggaran_id,
          };
      }else{
          params = {
              id_sppd: this.id,
              tlc : this.getAuth.username,
              anggaran_dtl_val_id: anggaran_id,
          };
      }
      return await axios({
        method: "get",
        url: this.$serviceUrl + "sppds/approval_sppd",
        params: params,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      });
    },
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        
        let diffDate = moment(values.jadwalDinas[1]).diff(moment(values.jadwalDinas[0]), 'days')
        if(values.jenis_perintah=="PD" && (diffDate<0 || diffDate>13)){
          this.displayMessageValue("error-other", "Interval date SPPD max only 14 days!");
          return
        }

        if (this.mode == "Create") {
          let approval = "";
          // this.getApproval(values.kode_anggaran).then((res) => {
            const dataValues = {
              ...values,
              tanggal_sppds: moment(values.tanggal_sppds).format(
                this.getStandartFormatDate
              ),
              jadwalDinas: [
                moment(values.jadwalDinas[0]).format(
                  this.getStandartFormatDate
                ),
                moment(values.jadwalDinas[1]).format(
                  this.getStandartFormatDate
                ),
              ],
              // approval: res.data.approval,
            };
            Event.$emit("collectData", {
              informasi: dataValues,
            });
          // });
        } else {
          const dataValues = {
            ...values,
            tanggal_sppds: moment(values.tanggal_sppds).format(
              this.getStandartFormatDate
            ),
            jadwalDinas: [
              moment(values.jadwalDinas[0]).format(this.getStandartFormatDate),
              moment(values.jadwalDinas[1]).format(this.getStandartFormatDate),
            ],
            approval: this.data.actorApproval,
          };
          Event.$emit("collectData", {
            informasi: dataValues,
          });
        }
      });
    },
    initJenisAnggaran(e){
        let filter = [];

        if(this.mode == 'Create'){
            // this.form.resetFields(["cost_center","peruntukan","sub_peruntukan", "kode_anggaran"]);
            filter = this.getNonTaktis.cost_center.filter(
                    (obj) => obj.jns_anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
            );
        }else{

            if(this.getNonTaktis.cost_center){
                filter = this.getNonTaktis.cost_center.filter(
                    (obj) => obj.jns_anggaran_id
                );
            }
        }

      this.modalanggaran.enabled = false;
      this.costCenter = filter;

    },
      handleJenisAnggaran(e){
        this.selectedCostCenter = e
          let filter = [];
          if(this.mode == 'Create'){
            this.form.setFieldsValue({cost_center: null});
            this.form.setFieldsValue({peruntukan: null});
            this.form.setFieldsValue({sub_peruntukan: null});
            this.form.setFieldsValue({kode_anggaran: null});
            this.modalanggaran.enabled = false;
            this.costCenter = [];
            this.peruntukan = [];
            this.subPeruntukan = [];
            this.anggaran = [];
              filter = this.getNonTaktis.cost_center.filter(
                  (obj) => obj.jns_anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
              );


          }
          this.costCenter = filter;
          this.modalanggaran.value = null;
      },
    initPeruntukan(e) {

      // this.form.resetFields(["sub_peruntukan", "kode_anggaran"]);
      // this.anggaran = [];
      const filter = this.getNonTaktis && this.getNonTaktis.sub_peruntukan ? this.getNonTaktis.sub_peruntukan.filter(
              (obj) => obj.peruntukan_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      ) : [];

      this.subPeruntukan = filter;
    },
    changeActivity_type(val){
      if(val=="Non Project"){
        this.$nextTick(function () {
          this.form.setFieldsValue({
            activity: null,
          });
        });
      }else{
        this.$nextTick(function () {
          this.form.setFieldsValue({
              pipeline_id: null,
          });
        });
      }
    },
  },
  watch: {
    "data.jenis_anggaran"() {
      if(this.data.jenis_anggaran=='07'){
        this.selectedCostCenter = this.data.jenis_anggaran || this.data.jns_anggaran_id
      }
    },
    "data.jns_anggaran_id"(){
      if(this.data.jns_anggaran_id=='07'){
        this.selectedCostCenter = this.data.jenis_anggaran || this.data.jns_anggaran_id
      }
    }
  }
};
</script>

<style lang="less">
.ant-select-selection-selected-value{
  width: 100%
}
.m-text-numberRight{
  input{
    text-align: right !important;
    padding-right: 25px;
  }
}
</style>
